import FormChangeableMixin from 'mixins/FormChangeableMixin'
import FormDisableableMixin from 'mixins/FormDisableableMixin'
import { importComponents } from '~/helpers'
import FormHideableMixin from 'mixins/FormHideableMixin'

export function inputProps(self) {
    const parts = self.valuePath.split('.')
    const valuePath = self.$attrs.formRepeater ? parts[parts.length - 1] : self.valuePath
    return {
        ...self.$props,
        value: self.$get(self.formData, valuePath),
        isInvalid: Boolean(self.errorMessage || self.$slots.error),
    }
}

export default {
    mixins: [FormChangeableMixin, FormDisableableMixin, FormHideableMixin],

    components: {
        ...importComponents(require.context('components/form-elements')),
        ...importComponents(require.context('components/form-inputs')),
    },

    props: {
        label: { type: String, default: undefined },
        placeholder: { type: String, default: undefined },
        hint: { type: String, default: undefined },
        error: { type: String, default: undefined },
        errorPath: { type: String, default: undefined },
        hasAutofocus: { type: Boolean, default: false },
        isRequired: { type: Boolean, default: false },
        isInline: { type: Boolean, default: false },
    },

    computed: {
        errorMessage() {
            return this.error || this.$validation.get(this.errorPath || this.valuePath)
        },

        fieldProps() {
            return {
                label: this.label,
                hint: this.hint,
                error: this.errorMessage,
                isInline: this.isInline,
                isDisabled: this.isDisabled,
                isHidden: this.isHidden,
            }
        },

        inputProps() {
            return inputProps(this)
        },
    },
}
